<template>
  <div>
    <v-card
      :style="[
        $vuetify.breakpoint.smAndDown
          ? { 'min-height': '100vh', 'background-color': '#f9f9f9' }
          : { 'background-color': '#f9f9f9' },
      ]"
    >
      <div style="margin-left: 10px; margin-right: 10px">
        <div
          class="pt-8"
          style="
            font-size: 20px;
            margin-left: 1rem;
            margin-right: 1rem;
            color: #444444;
          "
        >
          Transaction RoomBooking
        </div>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="12" sm="12">
              <div>
                <v-card
                  elevation="10"
                  style="padding: 2%; margin-bottom: 2%; margin-top: 2%"
                >
                  <v-row>
                    <v-col cols="12" md="2" class="mt-4">
                      <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="startDate"
                            label="Start Time"
                            append-icon="mdi-calendar"
                            outlined
                            hide-details="auto"
                            dense
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            clearable
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="startDate"
                          @change="menu1 = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="2" class="mt-4">
                      <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="endDate"
                            label="Expire Time"
                            append-icon="mdi-calendar"
                            outlined
                            hide-details="auto"
                            dense
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            clearable
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="endDate"
                          @change="menu2 = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="2" class="mt-4">
                      <v-autocomplete
                        :items="['Active', 'InActive']"
                        label="Status"
                        v-model="SearchStatus"
                        required
                        clearable
                        outlined
                        dense
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="5" class="mt-4">
                      <v-text-field
                        label="Search"
                        v-model="search"
                        clearable
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>  
                    <v-spacer></v-spacer>              
                    <v-col cols="12" md="6" lg="6" style="text-align: end">
                      <v-btn
                        :color="'blue'"
                        class="ma-2 white--text"
                        @click="SearchDataTransactionRoomBooking()"
                      >
                        Search
                        <v-icon right> mdi-magnify </v-icon>
                      </v-btn>
                      <v-btn
                        color="green"
                        class="ma-2 white--text"
                        @click="ExportTransactionRoomBooking()"
                      >
                        Export Excel
                        <v-icon right>mdi-file-excel-outline</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card>

                <v-card
                  elevation="10"
                  style="padding: 2%; margin-top: 2%; margin-bottom: 2%"
                >
                  <v-row>
                    <v-col cols="12" md="4"></v-col>
                    <v-col cols="12" md="3"></v-col>
                    <v-col cols="12" md="5" align="center">
                      <v-pagination
                        v-model="page"
                        :total-visible="6"
                        :length="pageCount"
                        @input="ChangePage(page)"
                      ></v-pagination>
                    </v-col>
                  </v-row>
                  <v-data-table
                    :headers="headers"
                    :items="DataList"
                    hide-default-footer
                    style="color: #332f2fde"
                    :items-per-page="itemsPerPage"
                    :page.sync="page"
                    single-line
                    hide-details
                  >
                    <template v-slot:item="{ item, index }">
                      <tr>
                        <td class="header-table-center-css">
                          {{ no_run + (index + 1) }}
                        </td>
                        <td class="header-table-center-css">
                          {{ item.bookingName }}
                        </td>
                        <td class="header-table-center-css">
                          {{ item.hostName }}
                        </td>
                        <td class="header-table-center-css">
                          {{ item.facility }}
                        </td>
                        <td class="header-table-center-css">
                          {{ ChangeFormatDate(item.startDate) }}
                        </td>
                        <td class="header-table-center-css">
                          {{ ChangeFormatDate(item.expireDate) }}
                        </td>
                         <td class="text-center">
                          <v-icon :color="item.checkInStatus ? 'green' : 'red'">
                            {{
                              item.checkInStatus
                                ? "mdi-check-circle"
                                : "mdi-close-circle"
                            }}
                          </v-icon>
                        </td>
                        <td class="text-center">
                          <v-icon :color="item.checkOutStatus ? 'green' : 'red'">
                            {{
                              item.checkOutStatus
                                ? "mdi-check-circle"
                                : "mdi-close-circle"
                            }}
                          </v-icon>
                        </td>
                        <td
                          style="
                            padding-bottom: 5px;
                            display: flex;
                            flex-direction: column-reverse;
                            align-items: center;
                          "
                        >
                          <v-btn
                            :color="GetColor(item.active)"
                            rounded
                            class="text-capitalize"
                            depressed
                            style="width: 120px"
                          >
                            <span :style="{ color: GetColorText(item.active) }">{{
                              item.active == true ? "Active" : "InActive"
                            }}</span>
                          </v-btn>
                        </td>
                        <td style="text-align: center">
                          <template>
                            <v-btn
                              class="mx-2"
                              fab
                              dark
                              small
                              color="orange"
                              @click="openTransactionRoomBookingDialog(item)"                         
                            >
                              <v-icon dark>mdi-eye</v-icon>
                            </v-btn>
                          </template>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                  <br />
                  <v-row class="mt-5">
                    <v-col cols="12" md="4"></v-col>
                    <v-col cols="12" md="3">
                      <v-pagination
                        v-model="page"
                        :total-visible="20"
                        :length="pageCount"
                        @input="ChangePage(page)"
                      ></v-pagination>
                    </v-col>
                    <v-col cols="12" md="3"></v-col>
                    <v-col cols="12" md="2">
                      <v-autocomplete
                        dense
                        solo
                        label="10/page"
                        v-model="itemsPerPage"
                        @input="ChangePerPage(itemsPerPage)"
                        :items="items"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog v-model="TransactionRoomBookingDialog" max-width="760px" persistent>
      <v-card class="rounded-xl">
        <v-card-title
          class="py-4 d-flex align-center"
          style="background-color: #00378E; color: white"
        >
          <v-icon class="mr-3">mdi-account-eye-outline</v-icon>
          <span class="text-h6 font-weight-bold">Transaction RoomBooking</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="TransactionRoomBookingDialog = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6 pb-6">
          <v-container fluid>
            <v-row>
              <v-col cols="12" md="4" class="label-col">
                <p class="label-text">BookingName : </p>
                <p class="label-text">HostName : </p>
                <p class="label-text">FacilityName : </p>
                <p class="label-text">DateTime : </p>
                <p class="label-text">CreateDate : </p>
              </v-col>

              <v-col cols="12" md="8">
                <p class="value-text">{{ BookingName }}</p>
                <p class="value-text">{{ HostName }}</p>
                <p class="value-text">{{ FacilityName }}</p>
                <p class="value-text">{{ DateTime }}</p>
                <p class="value-text">{{ CreateTime }}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <div class="loading-box">
        <div class="inter-load">
          <div class="rect rect1"></div>
          <div class="rect rect2"></div>
          <div class="rect rect3"></div>
          <div class="rect rect4"></div>
          <div class="rect rect5"></div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "TransactionRoomBooking",
  components: {},
  data() {
    return {
      loader: null,
      url: enurl.apiUrl,
      LoadingDialog: false,
      items: [10, 15, 20, 50, 100],
      no_run: null,
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,

      DataList: [],
      TowerList: [],
      menu: false,
      menu1: false,
      modal: false,
      menu2: false,

      startDate: "",
      endDate: "",
      SearchStatus: null,
      search: "",

      TransactionRoomBookingDialog: false,
      BookingName: "",
      HostName: "",
      FacilityName: "",
      DateTime: "",
      CreateTime: "",
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "No",
          sortable: false,
          align: "center",
        },
        {
          text: "BookingName",
          align: "center",
          sortable: false,
        },
        {
          text: "HostName",
          align: "center",
          sortable: false,
        },
        {
          text: "Facility",
          align: "center",
          sortable: false,
        },
        {
          text: "StartTime",
          align: "center",
          sortable: false,
        },
        {
          text: "ExpireTime",
          align: "center",
          sortable: false,
        },
        {
          text: "CheckInStatus",
          align: "center",
          sortable: false,
        },
        {
          text: "CheckOutStatus",
          align: "center",
          sortable: false,
        },
        {
          text: "Status",
          align: "center",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ];
    },
  },

  async mounted() {
    let self = this;
    // let date = new Date();
    // let currentDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
    // self.startDate = currentDate;
    await self.getDataTransactionRoomBooking();
  },

  methods: {
    getDataTransactionRoomBooking() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        page: 1,
        perpage: self.itemsPerPage,
        search: self.SearchName,
        startDate: self.startDate,
        endDate: self.endDate,
      };
      axios
        .post(`${self.url}Transaction/getDataTransactionRoomBooking`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.DataList = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    ChangePage(value) {
      let self = this;
      self.LoadingDialog = true;
      self.page = value;
      let temp = {
        page: value,
        perpage: self.itemsPerPage,
        search: self.SearchName,
        startDate: self.startDate,
        endDate: self.endDate,
      };
      axios
        .post(`${self.url}Transaction/getDataTransactionRoomBooking`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.DataList = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    ChangePerPage(value) {
      let self = this;
      self.LoadingDialog = true;
      self.page = 1;
      let temp = {
        page: 1,
        perpage: value,
        search: self.SearchName,
        startDate: self.startDate,
        endDate: self.endDate,
      };
      axios
        .post(`${self.url}Transaction/getDataTransactionRoomBooking`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.DataList = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    SearchDataTransactionRoomBooking() {
      let self = this;
      self.LoadingDialog = true;
      self.page = 1;
      let temp = {
        page: self.page,
        perpage: self.itemsPerPage,
        search: self.SearchName,
        startDate: self.startDate,
        endDate: self.endDate,
      };
      axios
        .post(`${self.url}Transaction/getDataTransactionRoomBooking`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.DataList = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    ExportTransactionRoomBooking() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        page: 1,
        perpage: self.itemsPerPage,
        search: self.SearchName,
        startDate: self.startDate,
        endDate: self.endDate,
      };
      axios
        .post(
          `${self.url}TransactionTurnstile/exportTransactionRoomBooking`,
          temp,
          {
            responseType: "blob",
          }
        )
        .then(function (response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const now = new Date();
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "TransactionRoombooking_ " +
              now.toLocaleString("th-TH") +
              ".xlsx"
          );
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    openTransactionRoomBookingDialog(data){
      let self = this;
      self.BookingName = data.bookingName;
      self.HostName = data.hostName;
      self.FacilityName = data.facility;
      self.DateTime = self.ChangeFormatDate(data.startDate) + " - " + self.ChangeFormatDate(data.expireDate);
      self.CreateTime = self.ChangeFormatDate(data.createTime);
      self.TransactionRoomBookingDialog = true;
    },

    base64ToBlob(base64, type = "application/octet-stream") {
      const binStr = atob(base64);
      const len = binStr.length;
      const arr = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }
      return new Blob([arr], { type: type });
    },

    ChangeFormatDate(date) {
      if (!date) return null;
      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },

    GetColor(value) {
      if (value == true) {
        return "rgb(92, 184, 92,0.3)";
      } else {
        return "rgb(232, 34, 34,0.3)";
      }
    },

    GetColorText(value) {
      if (value == true) {
        return "rgb(92, 184, 92)";
      } else {
        return "rgb(232, 34, 34)";
      }
    },
  },
};
</script>
<style scoped>
* >>> .v-data-table-header {
  background-color: black !important;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}
.addUserTitle {
  font-size: 14px;
  font-weight: 300;
}
.input-border {
  border: 1px solid black;
  height: 35px;
  padding: 4px;
}
.validation-class {
  color: red;
  font-size: 12px;
}
.header-table-css {
  text-align: left;
  cursor: pointer;
}
.header-table-center-css {
  text-align: center;
  cursor: pointer;
}

*,
::before ::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  background-color: #555555;
}

.loading-box {
  width: 150px;
  height: 100px;
  border: 5px solid #f1f1f1;
  /* margin: 100px auto; */
  position: relative;
}

.inter-load {
  width: 100px;
  height: 50px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.rect {
  background: #f1f1f1;
  display: inline-block;
  height: 60px;
  width: 7px;
  margin: 0 1px;
  animation: load 1.3s infinite ease-in-out;
}

@keyframes load {
  0% {
    transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
  }
  40% {
    transform: scaleY(0.4);
  }
  100% {
    transform: scaleY(0.4);
  }
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

.rect2 {
  animation-delay: -1.2s;
}
.rect3 {
  animation-delay: -1.1s;
}
.rect4 {
  animation-delay: -1s;
}
.rect5 {
  animation-delay: -0.9s;
}

.label-text {
  font-size: 18px;
  font-weight: 500;
  color: #555;
  margin: 8px 0;
}
.value-text {
  font-size: 18px;
  font-weight: 600;
  color: #111;
  margin: 8px 0;
}
</style>
